import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Headline from '../Elements/Headline'
import { Modal } from '../Elements/Modal'
import Text from '../Elements/Text'
import Button from '../Formik/Button'
import { useBudgets } from '../Sheets/lib/Hooks/Budget'

const TaskUpdateBudget = () => {
  const { t } = useTranslation('guide')
  const [showModal, toggleModal] = useState(false)
  const { data: budgets } = useBudgets()
  const navigate = useNavigate()

  const completeTask = async () => {
    navigate(`/budget/${budgets![0].id}`)
  }

  return (
    <>
      <Modal show={showModal} onHide={() => toggleModal(false)}>
        <Headline size='2xl' className='mb-4'>
          {t('guide:taskUpdateBudget.modal.title')}
        </Headline>
        <Text size='base' className='mb-4'>
          {t('guide:taskUpdateBudget.modal.description1')}
        </Text>
        <Text size='base' className='mb-8'>
          {t('guide:taskUpdateBudget.modal.description2')}
        </Text>
        <Button theme='blue' onClick={completeTask}>
          {t('guide:taskUpdateBudget.modal.confirm')}
        </Button>
      </Modal>
      <div className='flex flex-col justify-between h-[calc(100%-28px)]'>
        <div className='mb-4'>
          <Headline size='3xl' className='mb-2'>
            {t('guide:taskUpdateBudget.heading')}
          </Headline>
          <Text size='base'>{t('guide:taskUpdateBudget.description')}</Text>
        </div>
        <div className='flex justify-between items-center'>
          <Button theme='blue' onClick={completeTask}>
            {t('guide:taskUpdateBudget.update')}
          </Button>
        </div>
      </div>
    </>
  )
}

export default TaskUpdateBudget
